import { html, SYSBaseElement } from "../../../../../_ovlclient/src"
import type { SYSTableDefIds } from "../../../../../_ovlclient/src"
import { DialogClose } from "../../../../../_ovlclient/src/library/dialog/dialogapi"
import type { DialogHolderParams } from "../../../../../_ovlclient/src/library/dialog/dialogapi"
import { T } from "../../../../../_ovlclient/src/textapi"
import { NavDef } from "../../../../../_ovlclient/src/library/table/navcontrol"

export class DialogUserAdministrationUser extends SYSBaseElement {
  async init() {
    this.dialog = "SYSUserAdministration_User"
    await super.init()
  }
  async getUI() {
    let dialogHolderParams: DialogHolderParams
    dialogHolderParams = {
      dialogParts: {
        tableDefButtonsInFooter: "SYSUserAdministration_User",
        dismissedCallbackFn: () => {
          DialogClose(this.dialog)
        },
        title: () => T("SYSUserAdministrationUserTitle"),
        body: () => html`<ovl-table
          class="fd-table fd-table--no-horizontal-borders"
          .props=${() => <SYSTableDefIds>"SYSUserAdministration_User"}
        >
        </ovl-table>`,
      },
      dialogType: this.dialog,
    }
    return html`<ovl-dialogholder
      .dialogHolderParams=${dialogHolderParams}
    ></ovl-dialogholder>`
  }
}
